module.exports = __webpack_public_path__ + "static/media/20171212-_DSC2043_Small.1ed88839.jpg";